import { A9Service, AbstractDataProviderV2 } from 'components/system';
import { RsCustomerFinanceInfo } from 'common/customers/services/types/RsCustomerFinanceInfo';
import { CustomerUpdateFinance } from 'common/customers/services/types/CustomerUpdateFinance';

@A9Service('customerFinanceDataProvider')
export class CustomerFinanceDataProvider extends AbstractDataProviderV2<{}, RsCustomerFinanceInfo, {}, CustomerUpdateFinance> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{id}/finance');
    }

    public list(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public add(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public remove(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
